import {Scenario, StaticMethods} from './GeneralModels';
import {PersianKeyValue} from './SamanHealthFamilyModels';

export class HealthGroupOffer {
  public id: number;
  public name: string;
  public companyName: string;
  public services: PersianKeyValue[] = [];
  public overAllCoverage: string;
  public discountedAmount: string;
  public franchise: number;
  public cost: string;
  public discountsList: string[];

  constructor({id, name, companyName, services, franchise, overAllCoverage, discountedAmount, cost, discountsList}) {
    this.id = id;
    this.name = name;
    this.companyName = companyName;
    this.franchise = franchise;
    Object.entries(services).forEach(
      ([key, value]: [string, any]) => {
        this.services.push(new PersianKeyValue(StaticMethods.numberWithCommas(value), key));
      });
    this.overAllCoverage = overAllCoverage ? StaticMethods.numberWithCommas(overAllCoverage) : null;
    this.discountedAmount = discountedAmount ? StaticMethods.numberWithCommas(discountedAmount) : null;
    this.cost = StaticMethods.numberWithCommas(cost);
    this.discountsList = discountsList;
  }
}

export class HealthGroupRequest {
  public id: number;
  public applicantFirstName: string;
  public applicantLastName: string;
  public employeeCount: number;
  public dependantsCount: number;
  public companyName: number;
  public organizationName: string;
  public offerName: string;
  public DataFile: boolean;
  public paid: boolean;
  public status: boolean;
  public insuranceReleased: boolean;
  public currentStep: string;
  public viewArray: any;

  constructor(data: any, scenario: Scenario) {
    this.id = data.id;
    this.employeeCount = data.employeeCount;
    this.dependantsCount = data.dependantsCount;
    this.organizationName = data.organizationName;
    this.applicantFirstName = data.applicantFirstName;
    this.applicantLastName = data.applicantLastName;
    this.companyName = data.companyName;
    this.DataFile = data.DataFile;
    this.offerName = data.offerName;
    this.paid = data.paid;
    this.insuranceReleased = data.insuranceReleased;
    this.currentStep = StaticMethods.setStep(scenario, this.checkStepStatus, this);
    this.viewArray = {
      requestID: this.id,
      companyName: this.companyName,
      applicantFirstName: this.applicantFirstName,
      applicantLastName: this.applicantLastName,
      offerName: this.offerName,
      DataFile: this.DataFile + '_FILE_STATUS',
      paid_label: this.paid ? 'true_payment' : 'false_payment',
      status: this.currentStep
    };
  }

  private checkStepStatus = (step: string, object: HealthGroupRequest): boolean => {
    switch (step) {
      case HealthGroupScenario.dataFileSubmission:
        return object.DataFile;
      case HealthGroupScenario.paid:
        return object.paid;
      case HealthGroupScenario.waitingForRelease:
        return object.insuranceReleased;
      case HealthGroupScenario.insuranceReleased:
        return !object.insuranceReleased;
    }
  }
}


export class HealthGroupScenario {
  static readonly dataFileSubmission = 'dataFileSubmission';
  static readonly paid = 'paid';
  static readonly waitingForRelease = 'waitingForRelease';
  static readonly insuranceReleased = 'insuranceReleased';
  static generalScenario = new Scenario([
    HealthGroupScenario.paid,
    HealthGroupScenario.dataFileSubmission,
    HealthGroupScenario.waitingForRelease,
    HealthGroupScenario.insuranceReleased,
  ]);
  static B2BScenario = new Scenario([
    HealthGroupScenario.paid,
    HealthGroupScenario.dataFileSubmission,
    HealthGroupScenario.waitingForRelease,
    HealthGroupScenario.insuranceReleased,
  ]);

  constructor() {
  }
}
